import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AreaMap } from 'src/app/domain/area-map';
import { ClientMeasure } from 'src/app/domain/Demetra/client-measure';
import { AreaMapService } from 'src/app/services/area-map.service';
import { ClientMeasureService } from 'src/app/services/client-measure.service';
import { ProcessTerrainService } from 'src/app/services/process.service';
import { NotificationManager } from '../notification-manager';

@Component({
    selector: 'change-process-box',
    templateUrl: 'change-process-box.html',
    styleUrls: ['./change-process-box.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChangeProcessDialog implements OnInit {

    private interventionCode: string;
    samplingId: number;
    AreaMapList: AreaMap[] = [];
    SelectedMap!: AreaMap;
    OrderableList: ClientMeasure[] = [];
    SelectedOrderableSamplingId!: number;

    constructor(
        private snackbar: MatSnackBar,
        private clientMeasureService: ClientMeasureService,
        private areaMapService: AreaMapService,
        private processTerrainService: ProcessTerrainService,
        public dialogRef: MatDialogRef<ChangeProcessDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any) {

        this.interventionCode = data.interventionCode;
        this.samplingId = data.samplingId;
    }

    ngOnInit() {
        this.areaMapService.getAreaMapListByIntervention(this.interventionCode).subscribe(x => {
            this.AreaMapList = x;
        })
        this.clientMeasureService.getOrderableList(this.interventionCode).subscribe(x => {
            this.OrderableList = x.filter(x => ['I', 'Je', 'Jv', 'K', 'SEPTP1', 'SEPTP2', 'CNEPO', 'SEDFP', 'SPRMPC', 'CNEPE', 'CNEPV', 'AC'].includes(x.MeasureReferenceCode));
        });
    }

    onCancel() {
        this.dialogRef.close();
    }

    finish() {

        this.processTerrainService.changeProcess(this.interventionCode, this.samplingId, this.SelectedOrderableSamplingId, this.SelectedMap.Id).subscribe(x => {
            if (x) {
                NotificationManager.handleSuccess('Plan modifié', this.snackbar);
                this.dialogRef.close(x);
            }
        })
    }
}
